var _defs, _path, _path2, _circle, _circle2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBubbleSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M35.455 22.826c2.018-8.549-3.274-17.116-11.82-19.134-8.548-2.02-17.112 3.275-19.13 11.824-2.019 8.549 3.274 17.116 11.82 19.134 8.547 2.019 17.112-3.275 19.13-11.824z",
    fill: "#8E8E8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.888 15.447c.703-.09 1.355.407 1.35 1.116a9.5 9.5 0 01-16.205 6.666c-.502-.5-.388-1.313.175-1.743.563-.43 1.362-.31 1.888.164a6.932 6.932 0 0011.565-4.758c.04-.707.524-1.354 1.227-1.445z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.239,
    cy: 14,
    r: 2,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.239,
    cy: 12,
    r: 2,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleSmile);
export default __webpack_public_path__ + "static/media/bubble-smile.634f3b94.svg";
export { ForwardRef as ReactComponent };